import $ from "jquery";
import { toast } from "react-toastify";
import { apiURL } from "../utlis/config";
import store from "store";
// const apiURL = "http://172.105.35.119:8080/api";
var Actions = {
  ///trainee/notification
  addBrandInfo: (info, method) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/brands";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: method,
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: info,
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  updateBrandInfo: (info) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/brands";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: info,
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  fetchBrandsInfo: (
    brandId,
    brandStatus,
    page,
    pageSize,
    searchText,
    startDate,
    endDate
  ) => {
    //console.log({ pageSize, page, searchText, startDate, endDate });
    //console.log("startDate  ==", startDate !== "" ? searchText : undefined)

    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/brands";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: {
          brandId: brandId,
          brandStatus: brandStatus,
          limit: pageSize,
          page: page,
          searchText: searchText !== "" ? searchText : undefined,
          startDate:
            startDate !== "" && startDate !== "Invalid date"
              ? startDate
              : undefined,
          endDate:
            endDate !== "" && endDate !== "Invalid date" ? endDate : undefined,
        },
        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          } else {
            toast.error(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  deactivateBrandId: (brandId) => {
    //deactivateMemberId
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/brands";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: { brandId },

        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          } else {
            toast.error(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };

      $.ajax(settings).done();
    });
  },

  fetchBrandCategoryInfo: () => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/lists";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        success: function (response) {
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  onBrandReady: (brandId, publicStatus) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/brand/" + brandId + "/public";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: { public: publicStatus },
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  addCategoryInfo: (info, method) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/categories";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: method,
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: info,
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  updateCategoryInfo: (info) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/categories";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: info,
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  fetchCategorysInfo: (
    categoryId,
    categoryStatus,
    page,
    pageSize,
    searchText,
    startDate,
    endDate
  ) => {
    //console.log({ pageSize, page, searchText, startDate, endDate });
    //console.log("startDate  ==", startDate !== "" ? searchText : undefined)

    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/categories";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: {
          categoryId: categoryId,
          categoryStatus: categoryStatus,
          limit: pageSize,
          page: page,
          searchText: searchText !== "" ? searchText : undefined,
          startDate:
            startDate !== "" && startDate !== "Invalid date"
              ? startDate
              : undefined,
          endDate:
            endDate !== "" && endDate !== "Invalid date" ? endDate : undefined,
        },
        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          } else {
            toast.error(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  deactivateCategoryId: (categoryId) => {
    //deactivateMemberId
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/categories";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: { categoryId },

        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          } else {
            toast.error(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };

      $.ajax(settings).done();
    });
  },

  onCategoryReady: (categoryId, publicStatus) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/category/" + categoryId + "/public";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: { public: publicStatus },
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  addBannerImageInfo: (info, method) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/banner/image";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: method,
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: info,
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  updateBannerImageInfo: (info) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/banner/image";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: info,
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  fetchBannerImagesInfo: (
    bannerImageId,
    bannerImageStatus,
    page,
    pageSize,
    searchText,
    startDate,
    endDate
  ) => {
    //console.log({ pageSize, page, searchText, startDate, endDate });
    //console.log("startDate  ==", startDate !== "" ? searchText : undefined)

    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/banner/image";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: {
          bannerImageId: bannerImageId,
          bannerImageStatus: bannerImageStatus,
          limit: pageSize,
          page: page,
          searchText: searchText !== "" ? searchText : undefined,
          startDate:
            startDate !== "" && startDate !== "Invalid date"
              ? startDate
              : undefined,
          endDate:
            endDate !== "" && endDate !== "Invalid date" ? endDate : undefined,
        },
        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          } else {
            toast.error(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  deactivateBannerImageId: (bannerImageId) => {
    //deactivateMemberId
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/banner/image";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: { bannerImageId },

        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          } else {
            toast.error(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };

      $.ajax(settings).done();
    });
  },

  onBannerImageReady: (bannerImageId, publicStatus) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/banner/image/" + bannerImageId + "/public";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: { public: publicStatus },
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  
};

export default Actions;
